<script lang="ts">
  import { closeMobileMenu, themeStore } from "$lib/gpu-glossary";
  import Search from "$lib/ui/docs/Search.svelte";
</script>

<div
  class="gpu-glossary"
  style:--primary-color={$themeStore.primary[100]}
  style:--background-color={$themeStore.secondary[100]}
  style:--primary-color-light={$themeStore.primary[60]}
>
  <Search
    indexName="gpu_glossary"
    placeholder="Search GPU Glossary"
    onClose={closeMobileMenu}
  />
</div>

<style lang="postcss">
  .gpu-glossary :global(.DocSearch-Button) {
    background-color: var(--background-color) !important;
    height: auto;
    @apply px-3 py-1 rounded-none text-[var(--primary-color)] font-normal ml-0 w-full sm:h-auto h-[32px] transition-all;
  }
  .gpu-glossary :global(.DocSearch-Button):hover {
    @apply ring-1 ring-[var(--primary-color-light)] border text-[var(--primary-color)];
  }
  .gpu-glossary :global(.DocSearch-Button .DocSearch-Search-Icon) {
    @apply h-4 w-4 stroke-2 opacity-60 text-[var(--primary-color-light)];
  }
  .gpu-glossary :global(.DocSearch-Button .DocSearch-Button-Placeholder) {
    @apply block px-2 min-[1200px]:pr-24 text-sm;
  }
  .gpu-glossary :global(.DocSearch-Button .DocSearch-Button-Keys) {
    @apply hidden lg:flex min-w-0;
  }
  .gpu-glossary :global(.DocSearch-Button .DocSearch-Button-Key) {
    background: none;
    @apply font-sans text-sm p-0 mt-0.5 ml-1 mr-0 w-auto text-[var(--primary-color-light)];
  }
</style>
